import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CaseProvider } from "../../../contexts/CaseContext";
import Files from "../Files";
import Dashboard from "../dashboard/Dashboard";
import Revisions from "./Revisions";

const Router: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Revisions />} />  {/* ← Uses parent CaseProvider */}
      <Route
        path="/:revisionId"
        element={<Navigate to="dashboard" replace />}
      />
      <Route
        path="/:revisionId/files"
        element={
          <CaseProvider>  {/* ← New provider that can see :revisionId */}
            <Files />
          </CaseProvider>
        }
      />
      <Route
        path="/:revisionId/dashboard/*"
        element={
          <CaseProvider>  {/* ← New provider that can see :revisionId */}
            <Dashboard />
          </CaseProvider>
        }
      />
    </Routes>
  );
};

export default Router;
